export const initialData = {
  nome: '',
  nome_rota: '',
}
export default initialData;
